export default class UserPersona {

    constructor() {
        this.name = ''
        this.sites = []
        this.technicians = []
    }
}